module.exports = __webpack_public_path__ + "media/newstyle/images/Componente 6 – 2-3344be612fd06f579b52df55048a3870.svg";